import { render, staticRenderFns } from "./dotmatrixstatus.vue?vue&type=template&id=2cfa0d22"
import script from "./dotmatrixstatus.vue?vue&type=script&lang=js"
export * from "./dotmatrixstatus.vue?vue&type=script&lang=js"
import style0 from "./dotmatrixstatus.vue?vue&type=style&index=0&id=2cfa0d22&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports